(function () {
  'use strict';

  var ITEM_LIST_ID = 'be&lok';
  var ITEM_LIST_NAME = 'be&lok';

  function parsePrice(priceText) {
    return Number(String(priceText || '').split('$').join('').split(',').join('.')) || 0;
  }

  function getMappedProductMeta(itemId) {
    if (typeof product_handle_valueMap === 'undefined' || typeof product_handle_map === 'undefined') {
      return null;
    }
    if (!product_handle_map.has(itemId)) return null;
    return product_handle_valueMap[itemId];
  }

  function normalizeProductItem(productItem) {
    if (!productItem) return null;
    if (typeof productItem === 'string') return productItem.split('::');
    return productItem;
  }

  function buildGa4Item(productItem, itemListNameOverride) {
    var mapped = getMappedProductMeta(productItem[0]);
    return {
      item_id: productItem[0],
      item_name: mapped ? mapped[0] : productItem[8],
      index: productItem[2],
      item_list_id: ITEM_LIST_ID,
      item_list_name: itemListNameOverride || ITEM_LIST_NAME,
      item_category: mapped ? mapped[2] : '',
      item_category2: mapped ? mapped[3] : 'Standard',
      item_category3: String(productItem[6] || '').replace('Default Title', 'none'),
      item_variant: mapped ? mapped[1] : 'Truewireless',
      item_brand: 'SHOKZ',
      price: parsePrice(productItem[9]),
      quantity: Number(productItem[10]) || 1,
      currency: 'AUD'
    };
  }

  function pushOpendotsGa4Event(eventName, productItemRaw, buttonName, discountCents) {
    if (typeof window.dataLayer === 'undefined') return;

    var productItem = normalizeProductItem(productItemRaw);
    if (!productItem || !productItem[0]) return;

    var quantity = Number(productItem[10]) || 1;
    var price = parsePrice(productItem[9]);
    var item = buildGa4Item(productItem);
    item.quantity = quantity;

    if (discountCents > 0) {
      item.discount = discountCents / 100;
    }

    var eventParameters = {
      item_list_id: ITEM_LIST_ID,
      item_list_name: ITEM_LIST_NAME,
      currency: 'AUD',
      value: price * quantity,
      items: [item]
    };

    if (buttonName) {
      eventParameters.button_name = buttonName;
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: eventName,
      event_parameters: eventParameters
    });
  }

  function pushBuyNowBannerSelectItem(buttonName) {
    var checkedLabel = document.querySelector(
      '.template-product .product-form__item-1 .single-option-radio input[type="radio"]:checked + label'
    );
    var productDataEl = checkedLabel ? checkedLabel.querySelector('.product-data-div') : null;

    if (!productDataEl) {
      var activeColorLabel = document.querySelector('.options-color-wrapper.active');
      productDataEl = activeColorLabel ? activeColorLabel.querySelector('.product-data-div') : null;
    }

    if (!productDataEl) {
      productDataEl = document.querySelector('.product-data-div-first');
    }

    var raw1 = productDataEl ? productDataEl.getAttribute('data-product-data') : '';
    if (!raw1) return;

    var productItem = raw1.split('::');
    if (typeof window.dataLayer === 'undefined') return;

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'select_item',
      event_parameters: {
        item_list_id: ITEM_LIST_ID,
        item_list_name: ITEM_LIST_NAME,
        currency: 'AUD',
        button_name: buttonName,
        items: [buildGa4Item(productItem, 'Navigation _ ' + ITEM_LIST_NAME)]
      }
    });
  }

  function patchOpendotsProductGa4() {
    if (window.__opendotsProductGa4Patched) return;

    if (typeof window.product_page_ga4_deal !== 'function') return false;

    window.__opendotsProductGa4Patched = true;

    window.product_page_ga4_deal = function (productItem, buttonName, eventName) {
      pushOpendotsGa4Event(eventName, productItem, buttonName, 0);
    };

    if (typeof window.product_page_ga4_deal_with_discount === 'function') {
      window.product_page_ga4_deal_with_discount = function (productItem, buttonName, eventName, discount) {
        pushOpendotsGa4Event(eventName, productItem, buttonName, Number(discount) || 0);
      };
    }

    return true;
  }

  function initBuyNowBannerSelectItem() {
    document.addEventListener(
      'click',
      function (event) {
        var button = event.target.closest('.section-buy-now-banner-pc .bottom-wrapper button');
        if (!button || button.disabled) return;
        pushBuyNowBannerSelectItem((button.textContent || '').trim());
      },
      true
    );
  }

  function tryPatchOpendotsProductGa4() {
    if (patchOpendotsProductGa4()) return;

    var attempts = 0;
    var timer = window.setInterval(function () {
      attempts += 1;
      if (patchOpendotsProductGa4() || attempts >= 50) {
        window.clearInterval(timer);
      }
    }, 100);
  }

  tryPatchOpendotsProductGa4();
  initBuyNowBannerSelectItem();
})();
